import * as React from "react";
import { styled } from "utils";
import { useFormGroup } from "./formGroup";

const BaseInput = styled("input", {
  width: "100%",
  color: "$text",
  fontFamily: "inherit",
  fontSize: "$3",
  border: "1px solid $grey200",
  borderRadius: "$1",
  paddingY: 0,
  paddingX: "$3",
  "&::-webkit-input-placeholder": { color: "$placeholder" },
  "&::-moz-placeholder": { color: "$placeholder" },
  "&:-ms-input-placeholder": { color: "$placeholder" },
  '&[type="search"]::-webkit-search-decoration': { display: "none" },
  "&:focus": { outlineColor: "$secondary" },
  variants: { error: { true: { borderColor: "$error" } } },
});

const StyledInput = styled(BaseInput, { height: 56 });

type Props = React.ComponentProps<typeof StyledInput>;
type Ref = HTMLInputElement;

const Input = React.forwardRef<Ref, Props>((props, ref) => {
  const { error } = useFormGroup();
  return <StyledInput ref={ref} error={Boolean(error)} {...props} />;
});

Input.displayName = "Input";

export { Input, BaseInput };
